import { CSSObject } from '@emotion/react'
import { fonts, fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

enum fontSizeOptions {
  expanded = fontSizes.xxxLarge,
  scrollable = fontSizes.xLarge,
}

const getIndexIndicator = (
  isExpanded: boolean,
  width: number,
  isReadOnly: boolean
): CSSObject => ({
  color: isReadOnly ? colors.n1.base : colors.n6.base,
  display: 'flex',
  fontFamily: fonts.sourceCode,
  fontSize: isReadOnly
    ? fontSizeOptions[isExpanded ? 'expanded' : 'scrollable']
    : fontSizes.medium,
  justifyContent: 'center',
  marginBottom: '16px',
  marginTop: isReadOnly ? '16px' : 0,
  width: `${width}px`,
})

const getSectionBtnStyling = (readOnly: boolean): CSSObject => ({
  display: readOnly ? 'none' : 'flex',
  margin: '0 auto',
  position: 'sticky',
  top: 'calc(100% - 50px)',
  zIndex: 9999,
  'button.kuiper-asset-carousel-add-section': {
    backgroundColor: colors.gem.dark,
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.44)',
    color: colors.n1.base,
    padding: '20px',
    transition: 'color 0.1s ease',
    width: '335px',
    '&:hover': {
      color: colors.white.base,
    },
  },
  'button.kuiper-disabled': {
    color: colors.n1.base,
    opacity: '0.5',
    '&:hover': {
      color: colors.n1.base,
    },
  },
})

const styles = {
  getIndexIndicator,
  getSectionBtnStyling,
}

export { styles }
